import { createAction } from 'redux-actions';

import { LoadingServicesParamsState } from './reducers';

export const SET_LOADING_SERVICES_PARAMS = 'SET_LOADING_SERVICES_PARAMS';
export const ADD_LOADING_SERVICE_PARAM = 'ADD_LOADING_SERVICE_PARAM';
export const CLEAR_LOADING_SERVICES_PARAMS = 'CLEAR_LOADING_SERVICES_PARAMS';

export const setLoadingServicesParams = createAction<LoadingServicesParamsState>(SET_LOADING_SERVICES_PARAMS);

export type SetLoadingServiceTypesAction = ReturnType<typeof setLoadingServicesParams>;

export const addLoadingServiceParam = createAction<Partial<LoadingServicesParamsState>>(ADD_LOADING_SERVICE_PARAM);

export type AddLoadingServiceParam = ReturnType<typeof addLoadingServiceParam>;

export const clearLoadingServicesParams = createAction(CLEAR_LOADING_SERVICES_PARAMS);

export type ClearLoadingServiceTypesAction = ReturnType<typeof clearLoadingServicesParams>;

export type LoadingServiceActionTypes =
	| SetLoadingServiceTypesAction
	| AddLoadingServiceParam
	| ClearLoadingServiceTypesAction;
